<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>供应系统</el-breadcrumb-item>
        <el-breadcrumb-item>商品管理</el-breadcrumb-item>
        <el-breadcrumb-item>上菜管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="hx-form-container box-shadow">
      <el-form :model="listParams" label-width="100px">
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="领货日期：">
              <el-select clearable style="width: 100%" v-model="listParams.plaSupplyDateId" placeholder="请选择领货日期" size="small">
                <el-option v-for="item in dateList" :value="item.id" :key="item.id" :label="item.title"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item>
              <el-button size="small" type="primary" @click="loadTableData"> 查询 </el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <hx-table-result :show-pager-on-one-page="false" :page-info="pager" :loading="tableLoading" @page-current-change="handleCurrentChange" @page-size-change="handleSizeChange">
      <div slot="action"></div>

      <hx-table-result-col>
        <div class="wrap-table-info-display">
          <el-button :disabled="tableData.length === 0" class="align-left" type="primary" size="small" @click="adjustData"> 调整数据 </el-button>

          <el-button :disabled="tableData.length === 0" class="align-left" type="success" size="small" @click="dialogVisible = true"> 确认上菜 </el-button>

          <div class="table-info-display" style="font-weight: 600" v-if="deliveryTakenDate">
            <span>领货日期：</span>
            <span class="alert-text">{{ deliveryTakenDate | formatDate(true) }}</span>
          </div>
        </div>
      </hx-table-result-col>

      <el-table slot="content" :data="tableData" max-height="800" border>
        <el-table-column fixed align="center" width="60" label="序号">
          <template slot-scope="scope">
            <span v-text="(pager.pageIndex > 1 ? (pager.pageIndex - 1) * pager.pageSize : 0) + scope.$index + 1"> </span>
          </template>
        </el-table-column>

        <el-table-column fixed width="120" prop="title" align="center" label="产品名称"> </el-table-column>

        <el-table-column fixed width="100" prop="spec" align="center" label="规格"> </el-table-column>

        <el-table-column fixed width="120" prop="ability" align="center" label="基地供应能力"> </el-table-column>

        <el-table-column align="center" v-for="(item, index1) in columnList" :key="index1" :label="item.title">
          <el-table-column align="center" v-for="(item2, index2) in item.secondTitle" :key="index2" :label="item2" min-width="120">
            <template slot-scope="scope">
              <div class="line-height-style" v-for="(tableItem, index3) in scope.row.baseList" :key="index3" :title="tableItem[index1][index2]">
                {{ tableItem[index1][index2] }}
              </div>
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>
    </hx-table-result>
    <el-dialog class="hx-to-create-template" :title="dialogTitle" :visible.sync="dialogVisible" width="40%" @close="resetDialogForm" :close-on-click-modal="false">
      <div>
        <el-form ref="dialogForm" :model="itemParams" :rules="checkItemParams" label-width="120px">
          <el-form-item>
            <span>菜品一经上架，顾客即可下单购买，是否确认上菜？</span>
          </el-form-item>

          <el-form-item>
            <el-button :disabled="isDisabled" size="small" type="primary" @click="confirmDishing"> 确认上菜 </el-button>

            <el-button size="small" @click="dialogVisible = false"> 取 消 </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      listParams: {
        plaSupplyDateId: "",
        supplyId: "",
      },
      dateId: "",
      dateList: [],
      tableLoading: false,
      tableData: [],
      pager: {
        pageIndex: 1,
        pageSize: 15,
        total: 0,
      },
      isDisabled: false,
      columnList: [],
      deliveryBase: "",
      deliveryTakenDate: "",
      dialogTitle: "上菜确认",
      dialogVisible: false,
      itemParams: {
        categoryName: "",
        sort: 1,
      },
      checkItemParams: {
        categoryName: [{ required: true, message: "请输入分类名称", trigger: "blur" }],
        sort: [{ required: true, message: "请输入序号", trigger: "blur" }],
      },
    };
  },
  mounted() {
    this.listParams.supplyId = parseInt(this.$route.params.supplyId);
    this.loadDateList();
  },
  methods: {
    /**
     * 初始化领货日期
     */
    loadDateList() {
      this.$http({
        url: global.apiUrl + "/supply/goodputsale/supplyDate/findAll",
        method: "GET",
        params: {
          supplyId: this.listParams.supplyId,
        },
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            if (res.body.data) {
              if (res.body.data.length > 0) {
                this.dateList = res.body.data;
                if (this.dateList && this.dateList.length > 0) {
                  if (this.$route.query.dateId) {
                    this.listParams.plaSupplyDateId = this.$route.query.dateId;
                  } else {
                    this.listParams.plaSupplyDateId = this.dateList[0].id;
                  }
                  this.loadTableData();
                }
              } else {
                this.dateList = [];
                this.listParams.plaSupplyDateId = "";
              }
            } else {
            }
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * 初始化列表数据
     */
    loadTableData() {
      this.tableLoading = true;
      this.$http({
        url: global.apiUrl + "/supply/goodputsale",
        method: "GET",
        params: this.listParams,
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.tableLoading = false;
            if (res.body.data) {
              if (res.body.data.dataList && res.body.data.dataList.length > 0) {
                this.tableData = res.body.data.dataList;
              } else {
                this.tableData = [];
              }
              this.columnList = res.body.data.columnList;
              this.dateId = res.body.data.plaSupplyDateId;
              this.deliveryTakenDate = res.body.data.date;
            }
          } else {
            this.tableLoading = false;
          }
        })
        .catch(err => {
          this.tableLoading = false;

          console.error(err);
        });
      // const json = {"apiStatus":0,"sysStatus":0,"data":{"date":1524960000000,"dataList":[{"ability":88,"title":"番杏","spec":"份(约500g)","baseList":[[["测试基地1","12"],["测试基地1","3"],["测试基地1","5"],["测试基地1","0"],["","24"]],[["测试基地2","12"],["测试基地2","3"],["测试基地2","5"],["测试基地2","0"],["","24"]],[["测试基地3","0"],["测试基地3","0"],["测试基地3","0"],["测试基地3","0"],["","0"]],[["测试基地3","0"],["测试基地3","0"],["测试基地3","0"],["测试基地3","0"],["","0"]]]},{"ability":108,"title":"冰菜","spec":"份(约500g)","baseList":[[["测试基地1","34"],["测试基地1","0"],["测试基地1","0"],["测试基地1","0"],["","20"]],[["测试基地2","34"],["测试基地2","0"],["测试基地2","0"],["测试基地2","0"],["","20"]],[["测试基地3","0"],["测试基地3","0"],["测试基地3","0"],["测试基地3","0"],["","0"]],[["测试基地3","0"],["测试基地3","0"],["测试基地3","0"],["测试基地3","0"],["","0"]]]}],"columnList":[{"secondTitle":["基地","供应量"],"title":"供应点1"},{"secondTitle":["基地","供应量"],"title":"供应点2"},{"secondTitle":["基地","供应量"],"title":"供应点3"},{"secondTitle":["基地","供应量"],"title":"供应点4"}],"baseName":"xx基地（废除）"},"info":"success","timestamp":1524288499577};
      // this.deliveryBase = json.data.baseName;
      // this.deliveryTakenDate = json.data.date;
      // this.columnList = json.data.columnList;
      // this.tableData = json.data.dataList;
    },
    /**
     * 父组件获取子组件传递的开始日期
     * @param startAttr
     * @param startDate
     */
    getStartDate(startAttr, startDate) {
      if (startDate !== "") {
        this.listParams[startAttr] = new Date(startDate).getTime();
      } else {
        this.listParams[startAttr] = "";
      }
    },
    /**
     * 调整数据
     */
    adjustData() {
      this.$router.push({
        name: "adjustData",
        query: {
          dateId: this.dateId,
        },
      });
    },
    /**
     * 确认上菜
     */
    confirmDishing() {
      this.isDisabled = true;
      this.$http({
        url: global.apiUrl + "/supply/goodputsale/confirmSale",
        method: "GET",
        params: {
          supplyId: parseInt(this.$route.params.supplyId),
          plaSupplyDateId: this.listParams.plaSupplyDateId,
        },
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.$message.success(res.body.info);
            this.dialogVisible = false;
            this.isDisabled = false;
            this.loadDateList();
            this.tableData = [];
          } else {
            this.isDisabled = false;
          }
        })
        .catch(err => {
          this.isDisabled = false;

          console.error(err);
        });
    },
    /**
     * pageIndex的change事件
     * @param val
     */
    handleCurrentChange(val) {
      this.pager.pageIndex = val;
      this.loadTableData();
    },
    /**
     * pageSize的change事件
     * @param val
     */
    handleSizeChange(val) {
      this.pager.pageSize = val;
      this.loadTableData();
    },
    /**
     * 关闭对话框时重置表单
     */
    resetDialogForm() {
      this.$refs.dialogForm.resetFields();
    },
  },
};
</script>

<style lang="less" scoped>
.home-container {
  .alert-text {
    color: #e9a021;
    cursor: default;
  }
}
</style>
